import { createSlice } from "@reduxjs/toolkit";
import { getStudentUser, getStudentUserByID } from "./actionCreator";
import initialState from "./state";
import state from "./state";

export const studentSlice = createSlice({
  name: "student",
  initialState,
  reducers: {
    setPaginationModel(state, action) {
      state.students.page = action.payload.page;
      state.students.limit = action.payload.pageSize;
    },
    resetPaginationModel(state, action) {
      state.students.page = 0;
      state.students.limit = 25;
    },
    setAdvancedSearch(state, action) {
      console.log("ata to reached : action ",action);
      console.log("ata to reached : state ",state);
      
      // const newAdvancedSearch = action.payload;
      // const existingAdvancedSearch = JSON.parse(JSON.stringify(state.students.advancedSearch));
      // const advancedSearch = {...existingAdvancedSearch, ...newAdvancedSearch};
      state.students.advancedSearch = action.payload;
    },
    resetAdvancedSearch(action, payload) {
      state.students.advancedSearch = {};
    }
  },
  extraReducers: (builder) => {
    // GET Student User
    builder.addCase(getStudentUser.pending, (state) => {
      state.students.isLoading = true;
    });
    builder.addCase(getStudentUser.fulfilled, (state, action) => {
      console.log("action ki value : ", action);
      state.students.studentUserInfo = action?.payload?.data?.payload;
      state.students.isLoading = false
    });
    builder.addCase(getStudentUser.rejected, (state, action) => {
      state.students.isLoading = false
    });
  },
});


export const { setPaginationModel, setAdvancedSearch, resetAdvancedSearch } = studentSlice.actions;
export default studentSlice.reducer;
